module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "wrap-black text-center"
  }, [_vm._c('div', {
    staticClass: "container"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _vm._c('form', {
    staticClass: "form-pub",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [(_vm.currentUser.errors) ? _vm._c('div', _vm._l((_vm.currentUser.errors), function(msg) {
    return _vm._c('div', {
      staticClass: "alert alert-contrast alert-danger alert-dismissible",
      attrs: {
        "role": "alert"
      }
    }, [_vm._c('div', {
      staticClass: "message"
    }, [_vm._v(_vm._s(msg))])])
  })) : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "form-group"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.email),
      expression: "credentials.email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "email",
      "autofocus": "",
      "placeholder": "Your E-mail",
      "autocomplete": "off",
      "required": "required"
    },
    domProps: {
      "value": _vm._s(_vm.credentials.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._c('p', {
    staticClass: "xs-pt-20"
  }, [_vm._v("We will send you an email with a password reset link.")]), _vm._v(" "), (_vm.showSuccess) ? _vm._c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("We've sent you an email with a password reset link. Please check your emails for instructions.")]) : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "form-group xs-pt-10"
  }, [_vm._c('button', {
    staticClass: "btn-pub btn-pub-primary btn-pub-borderless fixed-width xs-full-width",
    attrs: {
      "disabled": !_vm.credentials.email || _vm.saving
    }
  }, [_vm._v(_vm._s(_vm.saving ? 'Please wait...' : 'Submit'))])]), _vm._v(" "), _vm._c('p', {
    staticClass: "xs-pt-30 footer-link"
  }, [_vm._v("Don't have a account? "), _vm._c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_vm._c('strong', [_vm._v("Sign up now")])]), _vm._v(".")], 1), _vm._v(" "), _vm._c('p', {
    staticClass: "footer-link"
  }, [_vm._v("Forgot your password? "), _vm._c('router-link', {
    attrs: {
      "to": "/forgot-password"
    }
  }, [_vm._c('strong', [_vm._v("Reset password")])]), _vm._v(".")], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('p', {
    staticClass: "xs-pb-20"
  }, [_vm._v("\n          Forgot Your Password?"), _vm._c('br'), _vm._v("\n          Please Enter Your Email Address Below.\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5217dbb6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/temp/login/ForgotPassword.vue
// module id = 664
// module chunks = 1